import { useMemo, useContext } from 'react'
import { AppDataContext } from '../providers/AppData'
import useTranslateMessage from './useTranslateMessage'
import getConfigVariable from '../utils/getConfigVariable'
import { TENANTS } from '../constants/global'
import { preloadImageLoader } from '../utils/imageLoaders'
import { useHomePageHrefLang } from './useHomePageHrefLang'

export default function useHomePageMeta() {
  const { language, locale } = useContext(AppDataContext)
  const translate = useTranslateMessage()
  const host = getConfigVariable('HOST')
  const hrefLangs = useHomePageHrefLang()

  return useMemo(() => {
    const title = translate('home-page.meta.title')
    const description = translate('home-page.meta.description')

    const canonicalUrl = `${host}/${locale}${locale === TENANTS.DE ? '/' : ''}`
    const preloadImage = preloadImageLoader({ src: 'hermes-static/logo.svg', host })

    return {
      title,
      description,
      canonicalUrl,
      language,
      preloadImage,
      hrefLangs
    }
  }, [host, hrefLangs, language, locale, translate])
}
